import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import Header from '../../component/page_parts/header';
import Footer from '../../component/page_parts/footer';
import TableOfContents from '../../component/page_parts/common/table_of_contents';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ReactGA from 'react-ga4';

type Detail = {
  title: string;
  management: string;
  type: string;
  img: string;
  layout: 'A' | 'B';
  formEmbedUrl?: string;
  imageMaxWidth?: number;
};

function getLogoDetailById(id: number) {
  switch (id) {
    case 1:
      return { title: 'Zenkenコーポレートロゴ', management: '総務部', type: 'コーポレート', img: '/zenken-logo-detail.png', layout: 'A', formEmbedUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfC8j4MENoiem-lx9NvRFyC7-YX_E3btibYZc1m9OXU7nbWew/viewform',};
    case 2:
      return { title: '50周年ロゴ', management: '総務部', type: 'コーポレート', img: '/zenken-50year-logo-detail.png', layout: 'A', formEmbedUrl: '埋め込み用URLをここに',}; 
    case 11:
      return { title: '戦コン　ポジメ', management: 'GNT－制作部', type: 'サービスロゴ', img: '/sennkonn-posime-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/MguAouE9r7Ber3eu6',}; 
    case 12:
      return { title: '戦コン　ブラメ', management: 'GNT－制作部', type: 'サービスロゴ', img: '/sennkonn-burame-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/455a34Rr6nD1bZ5c6',}; 
    case 13:
      return { title: '戦コン　グローバル', management: 'GNT－制作部', type: 'サービスロゴ', img: '/sennkonn-global-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/SjZGqenfenEzeLkM6',}; 
    case 14:
      return { title: '職ブラ', management: 'ワークエンゲージメント事業部', type: 'サービスロゴ', img: '/syokubura-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/SBSkFP1mKC8wocfz5',}; 
    case 15:
      return { title: 'キャククル', management: 'GNT－運用部', type: 'サービスロゴ', img: '/kyakukuru-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/WMsVrBgwjHLbbrJH9',};
    case 16:
      return { title: 'VOiCE', management: 'ワークエンゲージメント事業部', type: 'サービスロゴ', img: '/voice-logo.png', layout: 'B', formEmbedUrl: 'https://forms.gle/PQJV3pMBUtyEdf1n8',}; 
    case 17:
      return { title: 'エンゲージメンター', management: 'GNT事業本部運用', type: 'サービスロゴ', img: '/engage_mentor-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/chvc2Fp8u47hTMf88',}; 
    case 18:
      return { title: 'ページデリバリー', management: 'GNT－運用部', type: 'サービスロゴ', img: '/pagedelivery-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/hs1RePQdLNMnCmuF9',}; 
    case 19:
      return { title: 'ジャパンニッチトップ', management: 'GNT－制作部', type: 'サービスロゴ', img: '/japan niche top-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/hyuVVJ2NynVXVcij8',};
    case 20:
      return { title: 'らいく', management: 'コンテキストクリエイティブ部', type: 'サービスロゴ', img: '/raiku-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/Rp2tNx7hJgEd94z27',};

    // 海外人材セグメント（人材事業）
    case 30:
      return { title: 'Yaaay Freshers', management: 'ダイバーシティ事業部', type: 'サービスロゴ', img: '/yaaay-freshers-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/5UBvoqyY58JVVhcb6',}; 
    case 31:
      return { title: 'Yaaay', management: 'ダイバーシティ事業部', type: 'サービスロゴ', img: '/yaaay-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/RDAkhCBTzZSsPoS6A',}; 
    case 32:
      return { title: 'ZENKEN NIHONGO 介護', management: 'SSW事業部', type: 'サービスロゴ', img: '/zenken-nihonngo-kaigo-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/aYmfxrEWuEdx6S529',}; 
    case 33:
      return { title: 'ZENKEN 介護', management: 'SSW事業部', type: 'サービスロゴ', img: '/zenken_kaigo-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/uC5x5hYZ7V29TtYn6',}; 
    case 34:
      return { title: 'ZENKEN 宿泊', management: 'SSW事業部', type: 'サービスロゴ', img: '/zenken-syukuhaku-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/S2YDocBdMMrLLmPm6',}; 
    case 35:
      return { title: '全研ケア', management: 'SSW事業部', type: 'コーポレート', img: '/zenken-care-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/YFZEudvZJvufpSuE7',}; 
    case 36:
      return { title: '全研リビング', management: 'SSW事業部', type: 'サービスロゴ', img: '/zenken-living-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/WA3Ci5nA64rgWM7G7',}; 
    case 37:
      return { title: '美プロ', management: 'ヒューマンキャピタル事業本部', type: 'サービスロゴ', img: '/bipro-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/z4Com3t32SK5HWkz5',}; 
    case 38:
      return { title: '健康美容EXPO', management: 'ヒューマンキャピタル事業本部', type: 'サービスロゴ', img: '/health_beauty_expo-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/6MTAo7p6Ck9TdJDg8',}; 
    case 65:
      return { title: 'ZenNxt Labs', management: 'ダイバーシティ事業部', type: 'サービスロゴ', img: '/logo_ZenNxt_labs_main.png', layout: 'B', formEmbedUrl: 'https://forms.gle/D5mssXK3Snw5kbKc6', imageMaxWidth: 400,}; 

    // 海外人材セグメント（教育事業）
    case 40:
      return { title: 'リンゲージ', management: 'リンゲージ事業部', type: 'サービスロゴ', img: '/linguage-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/wxjJyujA2yKMx9yr7',}; 
    case 41:
      return { title: 'リンゲージスピーク', management: 'リンゲージ事業部', type: 'サービスロゴ', img: '/linguage-speak-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/Bman6XUUL83jsoMXA',}; 
    case 42:
      return { title: 'リンゲージ日本語学校', management: 'リンゲージ事業部', type: 'サービスロゴ', img: '/linguage-japanese-school-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/uVJYXmpEP22akhxa7',}; 
    case 43:
      return { title: 'おもてなし英会話', management: 'リンゲージ事業部', type: 'サービスロゴ', img: '/omotenashi-eikaiwa-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/jvZZakEnPsBjRPuZ7',}; 
    case 44:
      return { title: 'おもてなし英会話　心・旅館編', management: 'リンゲージ事業部', type: 'サービスロゴ', img: '/omotenashi-eikaiwa-kokororyokanhenn-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/zyNg4qcUkUav2bhu5',}; 
    case 45:
      return { title: 'グローバルスタディ', management: 'グローバルキャリア事業部　留学課', type: 'コーポレート', img: '/globalstudy-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/vjpUBnDy7JXA7qFs7',}; 
    case 46:
      return { title: 'AISE国際交流センター', management: 'グローバルキャリア事業部　留学課', type: 'サービスロゴ', img: '/aise-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/bDJrBuAMFW7GESJR7',}; 
    case 47:
      return { title: '一般財団法人海外留学推進協会', management: 'グローバルキャリア事業部　留学課', type: 'コーポレート', img: '/study Abroad Association-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/sEGi6sMyVvUjQwY56',}; 
    case 48:
      return { title: '米国大学スカラーシップ協会', management: 'グローバルキャリア事業部　留学課', type: 'サービスロゴ', img: '/scholarship-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/71i6VLrPmWcEtuPc8',}; 
    case 49:
      return { title: '麻布台留学パートナーズ', management: 'グローバルキャリア事業部　留学課', type: 'サービスロゴ', img: '/azabudairyugaku-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/SVYcFfFxKM3WA41g8',}; 
    case 50:
      return { title: 'グローバル人材育成ラボ', management: 'グローバルキャリア事業部　留学課', type: 'サービスロゴ', img: '/grobal-jinnzaiikuseilabo-logo-detail.png', layout: 'B', formEmbedUrl: 'https://forms.gle/5VpTHT3aDGPAEDwF6',};
    case 66:
      return { title: 'Zenken LifeCare', management: 'SSW事業部', type: 'サービスロゴ', img: '/zenkenLifeCare_logo.png', layout: 'B', formEmbedUrl: 'https://forms.gle/A3gHaG9eUp7nuN2v8', imageMaxWidth: 400,}; 

    default:
      return null;
  }
}


// 表示（共通：画像→title→management→type）
const DetailView: React.FC<{ detail: Detail }> = ({ detail }) => {
  const openUrl = detail.formEmbedUrl
    ? detail.formEmbedUrl.replace('?embedded=true', '')
    : '';

  return (
    <div className={`logo-detail-view layout-${detail.layout}`}>
      {/* ===== 共通（ここまで共通） ===== */}
      <div className="logo-detail-view__image">
      <img
        src={detail.img}
        alt={detail.title}
        style={detail.imageMaxWidth ? { maxWidth: `${detail.imageMaxWidth}px`, width: '100%' } : {}}
      />
      </div>

      <h2 className="logo-detail-view__title">{detail.title}</h2>

      <div className="logo-detail-discrpsion">
        <p className="logo-detail-view__management">管理部署：{detail.management}</p>
        {detail.type && <p className="logo-detail-view__type">種別：{detail.type}</p>}
      </div>

      {/* ===== ここから下が A/B でレイアウト変更 ===== */}
      {detail.layout === 'B' ? (
        <>
          {/* ---- Bパターン（利用方法～フォーム） ---- */}
          <h3 className="icon-title type-pencil">利用方法</h3>

          <div className="border-box">
            <p>
              Googleフォームに利用内容をご記入ください。フォーム送信後、メールでロゴが配布されます。
            </p>
            <a
href={openUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="border-box__btn"
    >
      Googleフォーム
      </a>
          </div>
        </>
      ) : (
        <>
          {/* ---- Aパターン（ここは仮：好きな構成にしてOK） ---- */}
          <h3 className="icon-title type-pencil">社内で利用</h3>

          <div className="border-box">
  <p>
    使用先が社内・社外問わず、社員が利用する場合はこちらを選んでください。<br />
    使用目的を明確にし、「楽楽精算 ＞ ワークフロー ＞ 汎用稟議書」より申請して下さい。
    申請後、ロゴデータを配布いたします。
  </p>
  <div className="border-box__buttons paternb">
  <a
      href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/"
      target="_blank"
      rel="noopener noreferrer"
      className="border-box__btn is-image"
    >
      <img
        src="/rakuraku.png"
        alt="楽楽精算"
        className="border-box__btn-image"
      />
      <img
        src="/caret-down-fill.png"
        alt=""
        className="border-box__btn-icon"
      />
    </a>
  </div>
</div>


          <h3 className="icon-title type-pencil">社外で利用（外部にお渡しする場合）</h3>
          <div className="border-box">
            <p>1.  使用許可申請書をダウンロードし、内容について相手方とすり合わせをしてください。<br />2. 内容が確定しましたら、「楽楽精算 ＞ ワークフロー ＞ 汎用稟議書」より使用許可申請書を添付の上、申請して下さい。</p>
            <div className="border-box__buttons paternb">
    {/* 左：テキストボタン */}
    <a
      href="https://docs.google.com/document/d/1cxaaJe0slmbBcj1S8nfCxeaK_NFgb00P5uMTobVf5sU/edit?tab=t.0"
      target="_blank"
      rel="noopener noreferrer"
      className="border-box__btn is-text"
    >
      使用申請書
      <img
        src="/caret-down-fill.png"
        alt=""
        className="border-box__btn-icon"
      />
    </a>

    {/* 右：画像ボタン */}
    <a
      href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/"
      target="_blank"
      rel="noopener noreferrer"
      className="border-box__btn is-image"
    >
      <img
        src="/rakuraku.png"
        alt="楽楽精算"
        className="border-box__btn-image"
      />
      <img
        src="/caret-down-fill.png"
        alt=""
        className="border-box__btn-icon"
      />
    </a>
  </div>
          </div>
        </>
      )}
    </div>
  );
};


const LogoDetailPage: React.FC = () => {
  // GA（今はそのまま）
  const gaId = process.env.REACT_APP_GA_ID;
  const userName =
    typeof window !== 'undefined'
      ? localStorage.getItem('user_name') || 'Unknown User'
      : 'Unknown User';

  if (gaId) {
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: 'event',
      eventCategory: userName,
      eventAction: 'ロゴ詳細-表示',
      eventLabel: 'logo-detail',
    });
  }

  const [searchParams] = useSearchParams();
  const layoutParam = (searchParams.get('l') || '').toLowerCase(); // official / service
  const idParam = searchParams.get('id');
  const id = idParam ? Number(idParam) : NaN;

  // id未指定
  if (isNaN(id)) {
    return (
      <>
        <Helmet><title>ロゴ詳細 - 指定なし</title></Helmet>
        <Header />
        <div className="theme-logoguide container" style={{ paddingTop: 24 }}>
          <p>
            ロゴIDが指定されていません。URLに <code>?l=service&id=11</code> のように付与してください。
          </p>
        </div>
        <Footer />
      </>
    );
  }

  // l の判定（official→A、service→B）
  const layoutAKeys = new Set(['official', 'a']);
  const layoutBKeys = new Set(['service', 'b']);

  let chosenLayout: 'A' | 'B' | null = null;
  if (layoutAKeys.has(layoutParam)) chosenLayout = 'A';
  else if (layoutBKeys.has(layoutParam)) chosenLayout = 'B';
  else chosenLayout = null;

  if (!chosenLayout) {
    return (
      <>
        <Helmet><title>ロゴ詳細 - レイアウト不明</title></Helmet>
        <Header />
        <div className="theme-logoguide container" style={{ paddingTop: 24 }}>
          <p>
            URLのレイアウト指定が不明です: <code>?l=official</code> または <code>?l=service</code> を指定してください。
          </p>
        </div>
        <Footer />
      </>
    );
  }

  const detail = getLogoDetailById(id);

  // idはあるがデータがない
  if (!detail) {
    return (
      <>
        <Helmet><title>ロゴ詳細 - 不明</title></Helmet>
        <Header />
        <div className="theme-logoguide container" style={{ paddingTop: 24 }}>
          <p>指定されたロゴが見つかりませんでした。（id: {id}）</p>
        </div>
        <Footer />
      </>
    );
  }

  // URLの l と detail.layout がズレてても、とりあえずURL優先で表示したいならここで上書き
  // 今日は「動く」を優先して detail.layout を chosenLayout に合わせる
  const fixedDetail: Detail = { ...detail, layout: chosenLayout };

  return (
    <>
      <Helmet><title>Z-link ロゴガイド</title></Helmet>
      <Header />

      <div className="theme-logoguide">
        <div className="content-header">
          <div className="container">
            <Row>
              <Col sm={7}>
                <h1 className="page-title type-logoguide">ロゴガイド</h1>
                <p className="description">Zenkenの使用可能なロゴです。規定に沿って適切に使用するようにお願いします。</p>
              </Col>
              <Col sm={5} className="align-bottom align-self-center mb-4">
                  <div className="page-title-area">
                    <button className="btn-link-area">
                      <a href="https://forms.gle/Bw6WbJVi4S9y8M4d7" target='_blanck'>ロゴの新規・変更・抹消フォーム</a>
                    </button>
                  </div >
              </Col >
            </Row>
          </div>
        </div>

        <TableOfContents />

        <div className="container" style={{ paddingTop: 24 }}>
          <Row>
            <Col>
              <DetailView detail={fixedDetail} />
            </Col>
          </Row>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default LogoDetailPage;
